var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolidinterfaceplus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 10,
    height: 10,
    rx: 1,
    fill: "#0B74BB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3913 5.3913C8.3913 5.17519 8.21611 5 8 5C7.78389 5 7.6087 5.17519 7.6087 5.3913V7.6087H5.3913C5.17519 7.6087 5 7.78389 5 8C5 8.21611 5.17519 8.3913 5.3913 8.3913H7.6087V10.6087C7.6087 10.8248 7.78389 11 8 11C8.21611 11 8.3913 10.8248 8.3913 10.6087V8.3913H10.6087C10.8248 8.3913 11 8.21611 11 8C11 7.78389 10.8248 7.6087 10.6087 7.6087H8.3913V5.3913Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidinterfaceplus);
export default __webpack_public_path__ + "static/media/solidinterfaceplus.13bad639120f8abc03fa263fa70348ae.svg";
export { ForwardRef as ReactComponent };